import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchMessageDelivery } from 'api/engage';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';

interface BodyProps {
    messageId: number;
    deliveryId: number;
}

const Body = (props: BodyProps) => {
    const { messageId, deliveryId } = props;
    const { accountId } = useCurrentAccount();

    const { data: messageDelivery } = useSuspenseQuery({
        queryKey: accountQueryKeys.engageDeliveryById(accountId, messageId, deliveryId),
        queryFn: () => fetchMessageDelivery(accountId, messageId, deliveryId),
    });

    return (
        <div className="flex flex-col gap-6">
            {messageDelivery.message.subject && <div>{messageDelivery.message.subject}</div>}
            <div
                className="max-w-[34.625rem] overflow-x-auto"
                dangerouslySetInnerHTML={{ __html: messageDelivery.body }}
            />
        </div>
    );
};

export { Body };
